import { render, staticRenderFns } from "./PosListCreate.vue?vue&type=template&id=2e2b0e7b"
import script from "./PosListCreate.vue?vue&type=script&lang=js"
export * from "./PosListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports